import React from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import './passwordField.scss';
import Utils from '../../lib/utils';

class PasswordField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            initialized: false,
            showPassword: false,
        };
    }

    componentDidMount() {
        const { defaultValue, input } = this.props;
        if (defaultValue) {
            input.onChange(defaultValue);
        }
        this.setState({ initialized: true });
    }

    componentWillUnmount() {
        this.setState({ initialized: false });
    }

    toggleShowPassword = () => {
        this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
    };

    render() {
        const {
            className,
            placeholder,
            input,
            id,
            disabled,
            meta: { touched, error, asyncValidating },
            getRef,
            showProgressBar = false,
            ...rest
        } = this.props;

        const { showPassword } = this.state;
        const progressBar = Utils.checkPasswordStrength(input.value);

        return (
            <div className={`password-field-container ${asyncValidating ? 'animating' : ''}`}>
                {input.value && showProgressBar && progressBar && progressBar.strength && (
                    <div className="progress-bar-container">
                        <p
                            className="progress-bar-text"
                            style={{ color: progressBar.strength.color || '#dc3545' }}
                        >
                            {progressBar.strength.text || 'Weak'}
                        </p>
                        <div className="progress-bar">
                            <div
                                className="progress-strength"
                                style={{
                                    width: `${progressBar.percentage || 0}%`,
                                    backgroundColor: progressBar.strength.color || '#dc3545',
                                }}
                            />
                        </div>
                    </div>
                )}
                <div className="input-wrapper">
                    <input
                        {...input}
                        {...rest}
                        id={id}
                        placeholder={placeholder}
                        type={showPassword ? 'text' : 'password'}
                        disabled={!!disabled}
                        ref={getRef}
                        value={input.value || ''}
                        className={touched && error ? 'error-border' : ''}
                        onChange={(e) => {
                            input.onChange(e.target.value);
                        }}
                        onBlur={(e) => {
                            input.onBlur(e.target.value);
                        }}
                    />
                    <button
                        type="button"
                        className="toggle-password"
                        onClick={this.toggleShowPassword}
                        disabled={disabled}
                        aria-label={showPassword ? 'Hide' : 'Show'}
                    >
                        {showPassword ? <FaEye /> : <FaEyeSlash />}
                    </button>
                </div>
                {touched && error && (
                    <span className="password-error">
                        {typeof error === 'object' ? error.errorMessage : error}
                    </span>
                )}
            </div>
        );
    }
}

export default PasswordField;